import React from 'react';

/**
 * Mission 10 admin button. Variants + sizes are className-driven; visuals live
 * in adminUi.css (token-based). `md` is the 44px primary-action target; use
 * `sm` for dense table rows (add hitSlop on the caller per decision #5).
 */
export type AdminButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type AdminButtonSize = 'md' | 'sm';

export interface AdminButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: AdminButtonVariant;
  size?: AdminButtonSize;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const AdminButton: React.FC<AdminButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  leftIcon,
  rightIcon,
  className = '',
  children,
  type = 'button',
  ...rest
}) => {
  const cls = [
    'admin-btn',
    `admin-btn--${variant}`,
    `admin-btn--${size}`,
    fullWidth ? 'admin-btn--full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} className={cls} {...rest}>
      {leftIcon}
      {children}
      {rightIcon}
    </button>
  );
};
